import { css } from "lit";
export default css `

    .summary {
        font-size: 1.1rem;
        font-family: var(--font-stack-bold), monospace;
        color: var(--secondary-color);
    }
    
    sl-details {
        max-width: 100%;
    }
    
    sl-details::part(header) {
        padding-top: 15px;
        height: 15px;
    }

    sl-details::part(base) {
        border: 1px dashed var(--bars-and-borders-dim);
        margin-bottom: var(--global-space);
        background-color: var(--background-color);
        border-radius: 0;
    }

    sl-details::part(content) {
        font-size: 0.9rem;
        padding: 0 0 0 var(--global-space);
        margin:0;
        overflow-x: auto;
        max-width: 100%;
        padding-bottom: var(--global-space)
    }
    
    .published {
        color: var(--font-color-sub1);
    }
    
    hr {
        margin-top: 0;
        border-top: 1px dashed var(--bars-and-borders);
        height: 1px;
        margin-bottom: var(--global-space);
    }
    
    .github_link {
        display: block;
        margin-bottom: var(--global-space)
    }
    
    .milestone {
        color: var(--primary-color);
        text-shadow:  0 0 10px var(--primary-text-shadow)
    }

    .latest {
        color: var(--terminal-text);
        text-shadow:  0 0 1rem var(--terminal-text-shadow);
        font-size: 1.2rem;
    }
    
    
    html[theme="light"] .latest {
        text-shadow:  none;
    }
    
    pb33f-kv-view {
        max-width: 500px;
    }

    @media only screen and (max-width: 800px) {

        sl-details {
            max-width: calc(100vw - 20px);
        }

    }
`;
